import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=2f9fc712"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"
import style0 from "./CookieNotice.vue?vue&type=style&index=0&id=2f9fc712&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports